import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
  section: {
    marginTop: 10,
    marginBottom: 20,
  },

  sectionTitle: {
    fontWeight: 'bold',
    textAlign: 'center',
    padding: 5,
    borderRadius: 5,
    color: theme.palette.primary.lighter,
    backgroundColor: theme.palette.primary.main,
    fontSize: 18,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '1rem',
  },
}))


